import { facilityAction, AuthActions } from '../../actions/constant';

const {
  GET_ASSIGNED_FACILITY_SUCCESS,
  GET_ASSIGNED_FACILITY_FAILURE,
  PRE_GET_ASSIGNED_FACILITY_SUCCESS,
  PRE_GET_ASSIGNED_FACILITY_FAILURE,
} = facilityAction;

const { THERAPIST_LOGOUT_SUCCESS } = AuthActions;

const intialFacilityState: object = {
  isGetFacilities: false,
  response: null,
};

export const getFacilityDropDownReducer = (state = intialFacilityState, action: any) => {
  switch (action.type) {
    case GET_ASSIGNED_FACILITY_SUCCESS:
    case PRE_GET_ASSIGNED_FACILITY_SUCCESS: {
      return {
        ...state,
        isGetFacilities: true,
        response: action.payload,
      };
    }

    case GET_ASSIGNED_FACILITY_FAILURE:
    case PRE_GET_ASSIGNED_FACILITY_FAILURE:
      return {
        ...state,
        isGetFacilities: false,
        response: action.payload,
      };

    case THERAPIST_LOGOUT_SUCCESS:
      return intialFacilityState;

    default:
      return state;
  }
};
